// modules
import { createAction } from 'redux-actions'

// actions
export const setPhones = createAction('PATIENT_PHONES_SET')
export const setAlertNote = createAction('PATIENT_ALERT_NOT_SET')
export const setEmails = createAction('PATIENT_EMAILS_SET')
export const setAddresses = createAction('PATIENT_ADDRESSES_SET')

export const setPatientAllergies = createAction('SET_PATIENT_ALLERGIES')
export const setPatientEvents = createAction('SET_PATIENT_EVENTS')

export const setAssignedCaregivers = createAction('SET_ASSIGNED_CAREGIVERS')
export const setAvailableCaregivers = createAction('SET_AVAILABLE_CAREGIVERS')

export const setPatientAlertNote = createAction('SET_PATIENT_ALERT_NOTE')
